export default __webpack_public_path__ + "static/media/bitmap.c513da11.svg";